import { combineReducers } from 'redux';
import { default as list } from 'exchange/reducers/exchange_list_reducers';
import { default as form } from 'exchange/reducers/exchange_form_reducers';

export const exchangeReducers = combineReducers({ list, form });



// WEBPACK FOOTER //
// src/modules/secured/modules/exchange/reducers/index.js